import React, { useState, useEffect } from "react";
import { useStopwatch } from 'react-timer-hook';
import PauseOutlinedIcon from '@mui/icons-material/PauseOutlined';
import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import { useDispatch, useSelector } from "react-redux";
import { slice } from "../Redux/mainRedux/mainSlice";
import * as actions from "../Redux/mainRedux/mainActions";

const TimerFooterCountup = ({ reprint_data, pick_ticket_id, onreprintclick, onExitClick, checkPause, totalTime, totalPauseTime, enableExit }) => {
  const { baseAPIURL, token, sessionStorage, timerdetail, pauseCount, pauseTime } = useSelector(state => state.slice);
  const dispatch = useDispatch();
  const [isPlay, setICon] = useState(false)
  const [totalPauseCountVal, setTotalPauseCount] = useState(0)

  // Click function for Pause / Play
  const isClick = () => {
    setICon(icon => !icon);
    if (!isPlay) {
      // Will Start Pause timer
      checkPause(true);
      // Will plus 1 in the pause count
      setTotalPauseCount(totalPauseCountVal => totalPauseCountVal + 1);
      setTotalPauseCount(totalPauseCountVal => totalPauseCountVal + pauseCount);
      dispatch(slice.actions.setpauseCount(totalPauseCountVal));
    } else {
      // Will Stop Pause timer
      checkPause(false);
      sendPauseTimer();
    }
  };
  // Will send total Pause time and count to separate API
  const sendPauseTimer = () => {
    const time = pauseTime + totalPauseTime;
    dispatch(slice.actions.setpauseTime(time));
    let body = { pause_duration: time, pause_count: totalPauseCountVal, apiSessionStorage: sessionStorage };
    dispatch(actions.generic_call(baseAPIURL, 'pickpack/pauseButtonPressed', body, 'post', token));
  }

  const {
    seconds,
    minutes,
    hours,
    start,
    pause,
  } = useStopwatch({
    autoStart: true, onExpire() {
      callCoTimer()
    }
  });

  // Will Update total time
  useEffect(() => {
    const time = convertToSec(hours, minutes, seconds);
    totalTime(time);
  }, [hours, minutes, seconds]);

  const callCoTimer = () => { }


  // Add additional ZERO at start if digit is in single figure
  const checkDigit = (val) => {
    return val < 10 ? `0${val}` : val;
  }
  // Will convert All Hours , Minutes and Seconds into Seconds
  const convertToSec = (hrs, mins, sec) => {
    const hrsToSec = hrs > 0 ? (hrs * 3600) : 0;
    const minsToSec = mins > 0 ? (mins * 60) : 0;
    const counterSeconds = hrsToSec + minsToSec + sec;
    dispatch(slice.actions.setTotalTimeSpend(counterSeconds));
    return counterSeconds
  }

  return (
    <>
      {/* <div className="formsubmit-container"> */}
      <div className="formsubmit-container cmb-15">
        <div className="backgroundColor-Type3 ScanScreen1Footer">
          {
            <div className={convertToSec(hours, minutes, seconds) > timerdetail?.cutoff_2_time && !isPlay ? "text_Flashing cpl-15 cpr-15 cpt-7 cpb-7 font-medium" : "cpl-15 cpr-15 cpt-7 cpb-7 font-medium"}> <span className={convertToSec(hours, minutes, seconds) > timerdetail?.cutoff_1_time && convertToSec(hours, minutes, seconds) < timerdetail?.cutoff_2_time ? "textColor-Type7" : ""}>Timer: {checkDigit(minutes)}</span>:<span className={convertToSec(hours, minutes, seconds) > timerdetail?.cutoff_1_time && convertToSec(hours, minutes, seconds) < timerdetail?.cutoff_2_time ? "textColor-Type7" : ""}>{checkDigit(seconds)}</span></div>
          }
          <div className="timer_outer">

            {isPlay ? <div className="timer_inner" onClick={start}>
              <PlayArrowIcon onClick={isClick} />
            </div>
              :
              <div className="timer_inner" onClick={pause}>
                <PauseOutlinedIcon onClick={isClick} />
              </div>
            }
          </div>
          <div className="pd-max cpl-10 cpr-10 cpb-5">
            <span className={!reprint_data || isPlay ? 'disableTile' : ''} onClick={reprint_data && !isPlay ? onreprintclick : undefined}>Reprint</span>
            <span> | </span>
            <span className={!enableExit || isPlay ? 'disableTile' : ''} onClick={enableExit && !isPlay ? onExitClick : undefined}>Exit</span>
          </div>

        </div>
      </div>
    </>
  )
}

export default TimerFooterCountup;